import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@cad-arc';
import { useFrBoloQueueFilterState } from '../state/fr-shared-queue-filters-context';

interface BoloListHeaderButtonProps {
    onClick: () => void;
    isActive: boolean;
}

export const FrBoloListHeaderButton = observer(
    ({ onClick, isActive }: BoloListHeaderButtonProps) => {
        const { numberOfItems } = useFrBoloQueueFilterState();

        return (
            <Button isActive={isActive} onClick={onClick}>
                BOLOs ({numberOfItems})
            </Button>
        );
    }
);
